
























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import L from 'leaflet';
import { Station } from '@/models/station';

type OpsFilterKey = 'maintenance' | 'inventory' | 'overdue';

@Component({})
export default class MaintenanceOverviewMapComponent extends Vue {
  @Prop({ default: () => [] }) stations!: Station[];
  @Prop({ default: false }) loading!: boolean;
  @Prop({ default: 'maintenance' }) filter!: OpsFilterKey;

  private url = 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png';
  private zoom = 3;
  private center: [number, number] = [30, 10];
  private clusterOptions = {
    disableClusteringAtZoom: 7,
    maxClusterRadius: 28,
    spiderfyOnMaxZoom: true,
  };

  private get mappableStations(): Station[] {
    return this.stations.filter(
      (station) => station.geoPosition && station.geoPosition.length === 2,
    );
  }

  @Watch('stations')
  @Watch('filter')
  onDataChange() {
    this.$nextTick(() => this.refreshMap());
  }

  mounted() {
    this.$nextTick(() => this.refreshMap());
  }

  private refreshMap() {
    this.invalidateMapSize();
    this.fitMapBounds();
  }

  private invalidateMapSize() {
    const mapComponent = this.$refs.map as { mapObject?: L.Map } | undefined;
    mapComponent?.mapObject?.invalidateSize();
  }

  private fitMapBounds() {
    const mapComponent = this.$refs.map as { mapObject?: L.Map } | undefined;
    const map = mapComponent?.mapObject;
    if (!map) return;

    if (!this.mappableStations.length) {
      map.setView(this.center, this.zoom);
      return;
    }

    const bounds = L.latLngBounds(
      this.mappableStations.map((station) => station.geoPosition as [number, number]),
    );
    map.fitBounds(bounds, { padding: [16, 16], maxZoom: 6 });
  }

  private getIcon(station: Station): L.DivIcon {
    let modifier = 'default';
    if (this.filter === 'inventory' || station.inventoryActive) {
      modifier = 'inventory';
    } else if (this.filter === 'overdue') {
      modifier = 'overdue';
    } else if (this.filter === 'maintenance') {
      modifier = 'maintenance';
    }

    return L.divIcon({
      className: 'overview-map-marker',
      html: `<span class="overview-map-marker__dot overview-map-marker__dot--${modifier}"></span>`,
      iconSize: [10, 10],
      iconAnchor: [5, 5],
    });
  }
}
